import React from 'react'
import { FeaturedProducts, Hero, Contact } from '../components'
const HomePage = () => {
  return (
    <main>
      <Hero />
      <FeaturedProducts />
      <Contact />
    </main>
  )
}

export default HomePage
